import React from 'react';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useGlobalState } from '../../global/context/global-context';
import { adminUrl, scpUrl, sgeUrl } from '../../../utils/environment';

export interface SystemLink {
  label: string;
  /** Nome completo, usado como dica quando o rótulo é uma sigla. */
  description?: string;
  href: string;
  icon: React.ReactElement;
}

/**
 * Links externos de serviços e sistemas exibidos na barra utilitária e no menu mobile
 * (abrem em nova aba).
 */
export const useSystemLinks = (): SystemLink[] => {
  const { applicationData } = useGlobalState();
  const cnpj = applicationData?.entity?.document || '';

  return [
    {
      label: 'Ouvidoria',
      href: `https://docgedsistemas.com.br/ouvidoria/inicio?codEntidade=${cnpj}&empresa=3851`,
      icon: <RecordVoiceOverIcon fontSize="small" />,
    },
    {
      label: 'Envio de Publicações',
      href: `https://docgedsistemas.com.br/sep/Home?codEntidade=${cnpj}&empresa=3851`,
      icon: <CloudUploadIcon fontSize="small" />,
    },
    {
      label: 'SCP',
      href: scpUrl(),
      icon: <AssignmentIcon fontSize="small" />,
    },
    {
      label: 'SGE',
      description: 'Sistema de Gestão de Emendas',
      href: sgeUrl(),
      icon: <AccountBalanceWalletIcon fontSize="small" />,
    },
    {
      label: 'Área Administrativa',
      href: adminUrl(),
      icon: <AdminPanelSettingsIcon fontSize="small" />,
    },
  ];
};
